import {MODAL_CLOSE, MODAL_SHOW} from "../actions/ModalActions";

const initialState = {
    modals: {},
};

export default function ModalReducer(state = initialState, action) {
    switch (action.type) {
        case MODAL_SHOW:
            return {
                modals: {
                    ...state.modals,
                    [action.payload.name]: {
                        show: true,
                        data: action.payload.data,
                    }
                }
            };

        case MODAL_CLOSE:
            return {
                modals: {
                    ...state.modals,
                    [action.payload.name]: {
                        show: false,
                        data: null,
                    }
                }
            };
    }

    return state;
}